// src/index.js
import React from "react";
import ReactDOM from "react-dom/client"; // Use 'react-dom/client' for React 18+
import App from "./App"; // Import the App component
import "./index.css"; // Import global styles here (optional)

const root = ReactDOM.createRoot(document.getElementById("root")); // Gets the root element
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
